import { useEffect } from "react";
import { connect } from "react-redux";
import DocumentMeta from "react-document-meta";
import { withRouter, Link } from "react-router-dom";
import RevSlider, { Slide, Caption } from "react-rev-slider";
import Slider from "react-slick";
import parse from "html-react-parser";
import bg3Img from "../../../../assets/images/bg3.jpg";
import bg4Img from "../../../../assets/images/how_it_works.svg";

import applyIcon from "../../../../assets/images/apply.png";
import loginIcon from "../../../../assets/images/login.png";
import gethelpIcon from "../../../../assets/images/get-help.png";
import contactusIcon from "../../../../assets/images/contacts.png";
import faqsIcon from "../../../../assets/images/faqs.png";
import "./styles.scss";
import { useTranslation } from 'react-i18next';
import projectOverImg from "../../../../assets/images/project-overview.png";

const HowItWorks = (props) => {
  //
  const { t } = useTranslation();
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const config = {
    delay: 9000,
    startwidth: 1170,
    startheight: 500,
    hideThumbs: 10,
    fullWidth: "on",
    forceFullWidth: "on",
  };
  const meta={
    title: 'MAARG',
    description: '',
    canonical: 'https://maarg.startupindia.gov.in/',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'Mentorship,startupindia,startup, mentor, Mentor , Startup'
        }
    }
};
  return (
    <DocumentMeta {...meta}>
      <div
        className="how-it-work-bg"
        style={{
          // background: { bg3Img },
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="w-100 pt-50 pb-50 position-relative content">
          <div className="container">
            <div className="row">
              <div className="sec-title text-center w-100 position-relative">
                <h2 className="mb-0 homepageFirstHeader">
                {t('How_it_Works')}
                  {/* How it Works */}
                  </h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-6 col-lg-3">
                <div className="button-po2 wow fadeInDown">
                  <a
                    className="rol-of-home homepageFirstDescription"
                    title=""
                    style={{ fontSize: "20px" }}
                  >
                    {/* Get A Mentor */}
                    {props.data && parse(props.data[0].Heading)}
                  </a>
                  <p className="mt-3 belowrolofhome homepageFirstDescription">
                    {/* Register your profile.
                    <br />
                    Get AI matchmaking recommendation based on sector, stage,
                    and functional skillset. */}
                    {props.data && parse(props.data[0].Text)}
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-lg-3">
                <div className="button-po2 wow fadeInUp">
                  <a
                    className="rol-of-home homepageFirstDescription"
                    title=""
                    style={{ fontSize: "20px" }}
                  >
                    {/* Send A Request */}
                    {props.data && parse(props.data[1].Heading)}
                  </a>
                  <p className="mt-3 belowrolofhome homepageFirstDescription">
                    {/* Select from the list recommended by platform AI or select
                    your own. Send request for confirmation. */}
                    {props.data && parse(props.data[1].Text)}
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-lg-3">
                <div className="button-po2 wow fadeInDown">
                  <a
                    className="rol-of-home homepageFirstDescription"
                    title=""
                    style={{ fontSize: "20px" }}
                  >
                    {/* Schedule Sessions */}
                    {props.data && parse(props.data[2].Heading)}
                  </a>
                  <p className="mt-3 belowrolofhome homepageFirstDescription">
                    {/* Set personalized goals. Manage mentorship interactions via
                    our guided approach and collaboration dashboard. */}
                    {props.data && parse(props.data[2].Text)}
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 col-lg-3">
                <div className="button-po2 wow fadeInUp">
                  <a
                    className="rol-of-home homepageFirstDescription"
                    title=""
                    style={{ fontSize: "20px" }}
                  >
                    {/* Manage Outcomes */}
                    {props.data && parse(props.data[3].Heading)}
                  </a>
                  <p className="mt-3 belowrolofhome homepageFirstDescription">
                    {/* Submit session reports, project reports, and feedback.
                    Monitor progress of the process, goals and outcomes. */}
                    {props.data && parse(props.data[3].Text)}
                  </p>
                </div>
              </div>
              <div className="col-lg-1"></div>
            </div>
            <div className="row wow fadeInUp" id="how-img">
              <div className="col-lg-1"></div>
              <div className="col-lg-10 text-center">
                <img src={bg4Img} />
              </div>
              {/* <div className="col-lg-1">
                <div class="apply wow slideInRight">
                  <ul style={{ paddingLeft: "20px" }}>
                    <li className="howitworksitem">
                      <img src={applyIcon} className="howitworksimg" />{" "}
                      <a href="">Apply</a>
                    </li>
                    <li className="howitworksitem">
                      <img src={loginIcon} className="howitworksimg" />{" "}
                      <a href="">Login</a>
                    </li>
                    <li className="howitworksitem">
                      <img src={gethelpIcon} className="howitworksimg" />{" "}
                      <a href="">Get Help</a>
                    </li>
                    <li className="howitworksitem">
                      <img src={contactusIcon} className="howitworksimg" />{" "}
                      <a href="">Contact Us</a>
                    </li>
                    <li className="howitworksitem">
                      <img src={faqsIcon} className="howitworksimg" />{" "}
                      <a href="">Faqs</a>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div class="row wow fadeInUp" id="how-img">
          <div class="col-lg-1"></div>
          <div class="col-lg-1"></div>
        </div>
      </div>
    </DocumentMeta>
  );
};

const mapStateToProps = (state) => {
  return {};
};
export default HowItWorks;
